export default __webpack_public_path__ + "static/media/health-dashboard.a39c8a5e.svg";